import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ForestDto } from '@system-shared/classes.dto';
import { ForestsService } from 'app/forests/services/forests.service';

@Component({
    selector: 'app-modify-forest',
    imports: [CommonModule, ReactiveFormsModule, RouterModule],
    templateUrl: './modify-forest.component.html',
    styleUrl: './modify-forest.component.scss'
})
export class ModifyForestComponent implements OnInit {
  loading: boolean;
  forestData: ForestDto;
  error: string | null = null;
  forestForm: FormGroup;
  forestCode: string;
  submitted: boolean;
  savedSuccessfully: boolean;

  constructor(private route: ActivatedRoute, private forestService: ForestsService, private fb: FormBuilder) {
    this.forestForm = this.fb.group({
      mapUrl: [''],
      districtOfficesUrl: [''],
      permitTypes: [''],
      active: [false],
    });
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const code = params.get('code');
      if (code) {
        this.forestCode = code;
        this.loadForestData(code);
      }
    });
  }

  loadForestData(code: string) {
    this.loading = true;
    this.forestService.getOne(code).subscribe({
      next: (data: ForestDto) => {
        this.forestData = data;
        this.populateForm(data);
        this.loading = false;
      },
      error: (error) => {
        console.error('Error fetching forest:', error);
        this.error = 'Failed to load forest data. Please try again.';
        this.loading = false;
      }
    });
  }

  populateForm(data: ForestDto): void {
    this.forestForm.patchValue({
      mapUrl: data.mapUrl,
      districtOfficesUrl: data.districtOfficesUrl,
      permitTypes: JSON.stringify(data.permitTypes, null, 2),
      active: data.active
    });
  }

  onSubmit(): void {
    if (this.forestForm.valid) {
      this.submitted = false;
      const updatedData = {
        ...this.forestData,
        ...this.forestForm.value,
        permitTypes: JSON.parse(this.forestForm.value.permitTypes),
      };

      this.forestService.updateForest(this.forestCode, updatedData).subscribe({
        next: ()=> {
          this.savedSuccessfully = true;
          this.loadForestData(this.forestCode);
        },
        error: (error) => {
          console.error('Error Saving:', error);
          this.savedSuccessfully = false;
        },
        complete: () => {
          this.submitted = true;
        }
      });
    }
  }
}
